import React from 'react';
import ContentLoader from 'react-content-loader';

const JwplayerLoader = () => (
  <ContentLoader
    height={365}
    width={486}
    speed={3}
    primaryColor="#3f484e"
    // secondaryColor="#bdc3c7"
  >
    <rect x="3" y="3" rx="10" ry="10" width="486" height="365" />
  </ContentLoader>
);

export default JwplayerLoader;
